import _classCallCheck from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';

/**
 * Based on https://github.com/sindresorhus/new-github-issue-url/blob/061fa0ddb7d51f3b96d3a0f6a6bebb196f105a7b/index.js
 * with node 8 + IE11 support i.e. not using URL (URLSearchParams.set replaced with Map.set)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function newGitHubIssueUrl(options) {
  var url = "".concat(process.env.SOURCE_CODE_REPO, "/issues/new");
  var query = Object.keys(options).map(function (type) {
    var value = options[type];
    return "".concat(type, "=").concat(encodeURIComponent(String(value)));
  }).join('&');
  return "".concat(url, "?").concat(query);
}
var DemoErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function DemoErrorBoundary() {
    var _this;
    _classCallCheck(this, DemoErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DemoErrorBoundary, [].concat(args));
    _this.state = {
      error: null
    };
    return _this;
  }
  _inherits(DemoErrorBoundary, _React$Component);
  return _createClass(DemoErrorBoundary, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        name = _this$props.name,
        onResetDemoClick = _this$props.onResetDemoClick,
        t = _this$props.t;
      var error = this.state.error;
      if (error) {
        var title = "[docs] Demo ".concat(name, " crashes");
        var searchQuery = encodeURIComponent("is:issue ".concat(title));
        var issueLink = newGitHubIssueUrl({
          title: title,
          body: "\n<!-- Please make sure you have fulfilled the following items before submitting -->\n<!-- Checked checkbox should look like this: [x] -->\n- [ ] I have [searched for similar issues](".concat(process.env.SOURCE_CODE_REPO, "/issues?q=").concat(searchQuery, ") in this repository and believe that this is not a duplicate.\n\n## Steps to reproduce\n1. Visit ").concat(window.location.href, "\n2. ??\n3. demo *").concat(name, "* crashes\n\n## Your environment\n| Tech         | Version |\n|--------------|---------|\n| Version  | v").concat(process.env.LIB_VERSION, "  |\n| Netlify deploy | ").concat(process.env.NETLIFY_DEPLOY_URL, " |\n| Browser      | ").concat(true && window.navigator ? window.navigator.userAgent : '*Unknown*', " |\n")
        });
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Typography, {
            color: "error",
            component: "p",
            variant: "h5",
            gutterBottom: true,
            children: "This demo had a runtime error!"
          }), /*#__PURE__*/_jsxs(Typography, {
            children: ['We would appreciate it if you ', /*#__PURE__*/_jsx(Link, {
              href: issueLink,
              rel: "noopener",
              target: "_blank",
              children: "report this error"
            }), " directly in our issue tracker with the steps you took to trigger it.\nThe \"report this error\" link prefills the issue description with valuable information."]
          }), /*#__PURE__*/_jsx("pre", {
            style: {
              whiteSpace: 'pre-wrap'
            },
            children: error.toString()
          }), /*#__PURE__*/_jsx(Button, {
            onClick: onResetDemoClick,
            variant: "text",
            children: t('resetDemo')
          })]
        });
      }
      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        error: error
      };
    }
  }]);
}(React.Component);
export { DemoErrorBoundary as default };
false ? void 0 : void 0;